import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="centered-page">
      <div className="card">
        <h1>Página não encontrada</h1>
        <p className="card__subtitle">O endereço acessado não existe neste portal.</p>
        <Link to="/">Voltar ao início</Link>
      </div>
    </div>
  );
}
